<template>
  <div class="mobile-i18n-page full_container">
    <CustomTabs :title="title" :hasBack="true" color="#ffffff" pb="18px" />
    <div class="bind_goods_container">
      <div class="bind_list">
        <!-- 提示条 -->
        <div class="bind-notice" v-if="isBoundGoods">
          <div class="bind-notice__text">
            <van-icon name="info-o" />
            <!-- 该商品已绑定，请勿重复绑定 -->
            <span>{{ $t("devUpdates.thisProductIsAlreadyLinked") }}</span>
          </div>
        </div>
        <div class="bind-notice" v-else-if="!hasLogin">
          <div class="bind-notice__text">
            <van-icon name="info-o" />
            <!-- 请先登录，再绑定商品 -->
            <span>{{ $t("devUpdates.logInBeforeLinkingTheProduct") }}</span>
          </div>
          <button class="login-link" type="button" @click="openLoginDialog">
            <!-- 去登录 -->
            <span>{{ $t("mobile.product.goToLogin") }}</span>
            <van-icon name="arrow" />
          </button>
        </div>

        <!-- 商品列表 -->
        <div class="bind-card" v-for="(item, index) in list" :key="index">
          <div class="bind-card__header">
            <span class="bind-card__time">{{
              $formatTime(item.createOn) || ""
            }}</span>
            <!-- 已绑定 -->
            <!-- 待绑定 -->
            <span
              class="bind-card__status"
              :class="{ 'bind-card__status--bound': isBoundGoods }"
            >
              {{
                isBoundGoods
                  ? $t("devUpdates.linked")
                  : $t("devUpdates.notLinked")
              }}
            </span>
          </div>

          <section class="bind-product">
            <van-image
              class="bind-product__image"
              radius="6px"
              :src="item.goodsImage || ''"
              fit="cover"
            />
            <div class="bind-product__body">
              <h3 class="bind-product__name">{{ item.title || "-" }}</h3>
              <div class="bind-product__identity">
                <span v-if="item.goodsBrand">
                  <!-- 品牌 -->
                  <span class="bind-product__muted">{{
                    $t("mobile.home.brand")
                  }}</span>
                  {{ item.goodsBrand }}
                </span>
                <span v-if="item.goodsBrand" class="bind-product__separator"
                  >·</span
                >
                <span>
                  <!-- 料号 -->
                  <span class="bind-product__muted">{{
                    $t("pcHome.partNumber")
                  }}</span>
                  {{ item.goodsNum || "-" }}
                </span>
              </div>
              <div class="bind-product__metrics">
                <span>
                  <!-- 数量 -->
                  <span class="bind-product__muted">{{
                    $t("mobile.home.quantity")
                  }}</span>
                  <strong
                    >{{
                      item.purchaseTotal === 0 || item.purchaseTotal
                        ? item.purchaseTotal
                        : "-"
                    }}{{ item.goodsUnit || "PCS" }}</strong
                  >
                </span>
                <span class="bind-product__multiply">×</span>
                <span class="bind-product__price">
                  <!-- 单价 -->
                  <span>{{ $t("mobile.home.unitPrice") }}</span>
                  <span class="bind-product__price-value">
                    {{ item.purchasePrice || item.salePrice || "-"
                    }}{{
                      getPriceUnitName(item.purchasePriceUnit || item.priceUnit)
                    }}
                  </span>
                </span>
              </div>
            </div>
          </section>

          <footer class="bind-actions">
            <!-- 返回 -->
            <van-button
              class="bind-action bind-action--secondary"
              size="small"
              @click="handleCancel"
              >{{ $t("pcProduct.back") }}</van-button
            >
            <!-- 确认绑定 -->
            <van-button
              v-if="!isBoundGoods"
              :disabled="!hasLogin || isBoundGoods || binding"
              :loading="binding"
              type="info"
              size="small"
              class="bind-action bind-action--primary"
              @click="handleConfirm"
              >{{ $t("devUpdates.confirmLinking") }}</van-button
            >
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Dialog } from "vant";
import CustomTabs from "@/components/CustomTabs.vue";
import { getMtsGoodsDetail } from "@/api/goods";
import { bindGoods } from "@/api/fastAccess";
import { getPriceUnitName } from "@/utils/vuexUnit";

export default {
  name: "bindGoods",
  data() {
    return {
      // 商品数组（支持遍历）
      list: [],
      isBoundGoods: false, // 是否已绑定商品
      binding: false, // 是否正在提交绑定
    };
  },
  components: {
    CustomTabs,
  },
  computed: {
    // 绑定商品
    title() {
      // 绑定商品
      return this.$t("goodsLibrary.bindProduct");
    },

    ...mapState({
      userInfo: (state) => state.user.userDetails,
      priceUnitTree: (state) => state.price.priceUnitTree,
      priceUnitCNY: (state) => state.price.priceUnitCNY,
      priceUnitUSD: (state) => state.price.priceUnitUSD,
    }),
    // 是否已登录
    hasLogin() {
      if (this.userInfo?.token) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getGoodsDetail();
  },
  methods: {
    // 打开登录对话框
    openLoginDialog() {
      console.log(this.$route.fullPath);
      this.$router.push({
        path: "/login",
        query: {
          backUrl: this.$route.fullPath,
        },
      });
    },
    // 获取商品详情
    getGoodsDetail() {
      const goodsCode = this.$route.query.goodsCode || "";
      getMtsGoodsDetail(goodsCode).then((res) => {
        if (res.code === 200) {
          this.list = [{ ...res.data }];
          this.isBoundGoods = this.list[0].traderUserId !== 0;
          // isBoundGoods 不等于0就是已经被绑定，等于0就是未被绑定
        }
      });
    },
    // 获取价格单位名称
    getPriceUnitName(currentUnit) {
      const priceConfig = {
        usdUnit: this.priceUnitUSD,
        cnyUnit: this.priceUnitCNY,
      };
      return getPriceUnitName(currentUnit, priceConfig);
    },
    // 处理取消按钮点击事件
    handleCancel() {
      this.$router.replace({ path: "/pc/home" });
    },
    // 处理确认按钮点击事件
    async handleConfirm() {
      if (this.binding || this.isBoundGoods) return;
      if (this.userInfo?.authnStatus === 0) {
        this.showRealnameConfirm();
        return;
      }

      this.binding = true;
      try {
        const res = await bindGoods({ goodsId: this.list[0].goodsId });
        if (res.code === 200) {
          this.isBoundGoods = true;
          // 绑定商品成功!
          this.$myMessage.success(
            // 绑定商品成功!
            this.$t("devUpdates.productLinkedSuccessfully")
          );
          setTimeout(() => {
            this.$router.replace({ path: "/pc/myxg/myGoods" });
          }, 1500);
        }
      } finally {
        this.binding = false;
      }
    },
    showRealnameConfirm() {
      const message = "《网络安全法》规定，实名才可发布信息，前往实名认证！";
      Dialog.confirm({
        // 温馨提示
        title: this.$t("mobile.product.notice"),
        message,
        // 前往实名认证
        confirmButtonText: this.$t("supplyHall.goRealname"),
        // 取消
        cancelButtonText: this.$t("business.cancel"),
      })
        .then(() => {
          this.$router.push({ path: "/realname" });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.full_container {
  --page-bg: #f5f7fa;
  --surface: #ffffff;
  --text-primary: #1f2937;
  --text-secondary: #667085;
  --text-tertiary: #98a2b3;
  --border-color: #eaecf0;
  --brand-blue: #246bfd;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--page-bg);
}

.bind_goods_container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 12px calc(20px + env(safe-area-inset-bottom));
  background: var(--page-bg);
  box-sizing: border-box;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.bind_list {
  width: 100%;
}

.bind-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 34px;
  margin-bottom: 10px;
  padding: 6px 10px;
  border-radius: 8px;
  background: var(--surface);
  color: #475467;
  font-size: 12px;
  line-height: 20px;
  box-sizing: border-box;

  &__text {
    display: flex;
    align-items: center;
    min-width: 0;

    .van-icon {
      flex: 0 0 auto;
      margin-right: 6px;
      color: var(--brand-blue);
      font-size: 15px;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.login-link {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  min-height: 28px;
  margin: -4px -4px -4px 8px;
  padding: 4px;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--brand-blue);
  font: inherit;
  font-weight: 500;
  cursor: pointer;

  .van-icon {
    margin-left: 2px;
    font-size: 12px;
  }
}

.bind-card {
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 10px;
  background: var(--surface);
  color: var(--text-primary);
  box-sizing: border-box;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 44px;
    margin: -12px -12px 8px;
    padding: 6px 8px 6px 12px;
    border-bottom: 1px solid #edf0f5;
    border-radius: 10px 10px 0 0;
  }

  &__time {
    color: var(--text-tertiary);
    font-size: 12px;
    line-height: 18px;
  }

  &__status {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 7px;
    border: 1px solid #d7e5ff;
    border-radius: 5px;
    background: #f4f8ff;
    color: var(--brand-blue);
    font-size: 11px;
    line-height: 20px;
    box-sizing: border-box;

    &--bound {
      border-color: #e2e7ef;
      background: #f7f9fc;
      color: var(--text-secondary);
    }
  }
}

.bind-product {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  min-width: 0;
  padding: 7px 0;

  &__image {
    width: 58px;
    height: 58px;
    overflow: hidden;
    border-radius: 6px;
    background: #f7f9fc;
  }

  &__body {
    min-width: 0;
  }

  &__name {
    display: -webkit-box;
    min-width: 0;
    margin: 0;
    overflow: hidden;
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    overflow-wrap: anywhere;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &__identity,
  &__metrics {
    display: flex;
    min-width: 0;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 2px 6px;
    margin-top: 4px;
    color: var(--text-secondary);
    font-size: 12px;
    line-height: 17px;
    overflow-wrap: anywhere;
  }

  &__metrics {
    margin-top: 5px;
    color: #475467;
    font-size: 13px;

    strong {
      color: #344054;
      font-weight: 500;
    }
  }

  &__muted {
    margin-right: 3px;
    color: var(--text-tertiary);
    font-size: 12px;
  }

  &__price {
    color: var(--text-tertiary);
    font-size: 12px;
  }

  &__price-value {
    margin-left: 3px;
  }

  &__separator,
  &__multiply {
    color: #b0b8c4;
  }
}

.bind-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 3px -12px 0;
  padding: 10px 12px 0;
  border-top: 1px solid #eef1f5;

  .bind-action {
    position: relative;
    flex: 0 0 auto;
    min-width: 68px;
    height: 32px;
    margin: 4px 0;
    padding: 0 11px;
    border-radius: 7px;
    font-size: 13px;
    white-space: nowrap;

    &::before {
      content: "";
      position: absolute;
      inset: -6px 0;
    }
  }

  .bind-action--secondary {
    border-color: #d9e2ef;
    background: var(--surface);
    color: #475569;
  }

  .bind-action--primary {
    border-color: #5f91dc;
    background: #4f83d1;
    color: #ffffff;

    &.van-button--disabled {
      border-color: #d7dce5;
      background: #e7eaf0;
      color: #98a2b3;
      opacity: 1;
    }
  }
}

@media (max-width: 350px) {
  .bind_goods_container {
    padding-right: 10px;
    padding-left: 10px;
  }

  .bind-card {
    padding: 11px;

    &__header {
      margin: -11px -11px 8px;
      padding-right: 7px;
      padding-left: 11px;
    }
  }

  .bind-actions {
    margin-right: -11px;
    margin-left: -11px;
    padding-right: 11px;
    padding-left: 11px;
  }

  .bind-notice {
    padding-right: 8px;
    padding-left: 8px;
  }
}
</style>
